'use client';

import { useEffect } from 'react';

// Recarga automática tras cada deploy en staging/qa: consulta /api/version y,
// cuando el deploy activo cambia, recarga la página sola — se acabó el
// Cmd+Shift+R para ver lo último. Solo en staging/qa (en producción una
// recarga sorpresa molestaría a un cliente), y NUNCA en medio de una edición
// con cambios sin guardar.
const HOSTS = ['staging.ezdocu.ai', 'qa.ezdocu.ai', 'localhost'];
const INTERVALO_MS = 60_000;

export default function AutoRefresh() {
  useEffect(() => {
    if (!HOSTS.includes(window.location.hostname)) return;
    let version: string | null = null;
    let pendiente = false;

    const editorSucio = () => {
      try {
        const tiny = (window as any).tinymce;
        return Boolean(tiny?.editors?.some?.((e: any) => e.isDirty?.()) || tiny?.activeEditor?.isDirty?.());
      } catch {
        return false;
      }
    };

    const recargarSiSePuede = () => {
      if (!pendiente) return;
      if (editorSucio()) return; // reintenta en el próximo ciclo
      window.location.reload();
    };

    const revisar = async () => {
      try {
        const res = await fetch('/api/version', { cache: 'no-store' });
        if (!res.ok) return;
        const { v } = await res.json();
        if (!v) return;
        if (version === null) { version = v; return; }
        if (v !== version) { pendiente = true; recargarSiSePuede(); }
      } catch { /* sin red: se reintenta luego */ }
    };

    const id = window.setInterval(revisar, INTERVALO_MS);
    const alVolver = () => { if (document.visibilityState === 'visible') { revisar().then(recargarSiSePuede); } };
    document.addEventListener('visibilitychange', alVolver);
    revisar();
    return () => { window.clearInterval(id); document.removeEventListener('visibilitychange', alVolver); };
  }, []);

  return null;
}
